import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";
import type { CoachRecommendation } from "@shared/schema";

export function usePendingRecommendations() {
  const { data: recommendations = [], isLoading, refetch } = useQuery<CoachRecommendation[]>({
    queryKey: ['/api/recommendations'],
    staleTime: 30 * 1000,
  });

  const pendingRecommendations = useMemo(() => 
    (recommendations || []).filter(r => r.status === 'pending'),
  [recommendations]);

  return {
    recommendations,
    pendingRecommendations,
    pendingCount: pendingRecommendations.length,
    isLoading,
    refetch,
  };
}
